import { useAppSelector } from "Redux/hooks";
import { Fragment } from "react";
import { Module, Trigger, TriggerBody } from "types/type.module";
import { extractLogicalOperation } from "../../Logic/Steps";
import { resolveElementLabel } from "../Atoms/ElementLabel";
import { selectCurrentModule } from "Redux/ProducerSlice";

/*
  @function ConditionEquation
  render condition equation string
  @param condition {object} - condition to render
  @returns {React.Node}
*/
export default function ConditionEquation({
  condition = {},
}: {
  condition: Record<string, any>;
}) {
  const currentModule = useAppSelector(selectCurrentModule);

  if (!currentModule) return null;

  return (
    <div style={{ background: "#1D1E1C" }} className="text-center py-4">
      <p className="text-white">
        {renderCondition(condition, false, currentModule)}
      </p>
    </div>
  );
}

/*
  @function isConclusion
  is trigger a conclusion
  @param trigger {object}
  @param module {object}
  @return boolean
*/
function isConclusion(trigger: Trigger | TriggerBody, module: Module): boolean {
  let isConclusion = false;

  module.chapters.forEach((c) => {
    if (
      typeof trigger !== "string" &&
      "chapter" in trigger &&
      c.chapter_id === trigger.chapter
    ) {
      c.questions.forEach((q) => {
        if (q.question_id === trigger.question && q.conclusion) {
          isConclusion = true;
        }
      });
    }
  });
  return isConclusion;
}

/*
  @function renderCondition
  navigate through conditiona and render it
  @param condition {object} - condition of step
  @param isNegated {boolean} - are next step negated? 
*/
function renderCondition(
  condition: Trigger | TriggerBody,
  isNegated: boolean,
  module: Module
) {
  if (isNegated === null) isNegated = false;
  const operation = extractLogicalOperation(condition);

  if (operation.operation === "or") {
    return (
      <Fragment key={(Math.random() + 1).toString(36).substring(7)}>
        {operation.elements && operation.elements.length > 1 && " ( "}
        {operation.elements &&
          operation.elements.map((el: any, i: any) => {
            if (el === "always") {
              return el;
            }

            if ("question" in el) {
              if (isConclusion(el, module)) {
                return (
                  <Fragment key={(Math.random() + 1).toString(36).substring(7)}>
                    {el.negated ? "not " : ""}
                    <span
                      className={el.negated ? "text-red-500" : "text-green-500"}
                    >
                      {resolveElementLabel(el, module)}
                    </span>
                    {operation.elements && i !== operation.elements.length - 1
                      ? " and "
                      : ""}
                  </Fragment>
                );
              }
            }
            if ("answer" in el) {
              return (
                <Fragment key={(Math.random() + 1).toString(36).substring(7)}>
                  {el.negated ? "not " : ""}
                  <span
                    className={el.negated ? "text-red-500" : "text-green-500"}
                  >
                    {el.label}
                  </span>
                  {operation.elements && i !== operation.elements.length - 1
                    ? " or "
                    : ""}
                </Fragment>
              );
            } else {
              return (
                <Fragment key={(Math.random() + 1).toString(36).substring(7)}>
                  {renderCondition(el, isNegated, module)}
                  {operation.elements && i !== operation.elements.length - 1
                    ? " or "
                    : ""}
                </Fragment>
              );
            }
          })}
        {operation.elements && operation.elements.length > 1 && " ) "}
      </Fragment>
    );
  }

  if (operation.operation === "and") {
    return (
      <Fragment key={(Math.random() + 1).toString(36).substring(7)}>
        {operation.elements && operation.elements.length > 1 && " ( "}
        {operation.elements &&
          operation.elements.map((el: any, i: any) => {
            if (typeof el !== "string" && "question" in el) {
              if (isConclusion(el, module)) {
                return (
                  <Fragment key={(Math.random() + 1).toString(36).substring(7)}>
                    {el.negated ? "not " : ""}
                    <span
                      className={el.negated ? "text-red-500" : "text-green-500"}
                    >
                      {resolveElementLabel(el, module)}
                    </span>
                    {operation.elements && i !== operation.elements.length - 1
                      ? " and "
                      : ""}
                  </Fragment>
                );
              }
            }

            if (typeof el !== "string" && "answer" in el) {
              return (
                <Fragment key={(Math.random() + 1).toString(36).substring(7)}>
                  {el.negated ? "not " : ""}
                  <span
                    className={el.negated ? "text-red-500" : "text-green-500"}
                  >
                    {el.label}
                  </span>
                  {operation.elements && i !== operation.elements.length - 1
                    ? " and "
                    : ""}
                </Fragment>
              );
            } else {
              return (
                <Fragment key={(Math.random() + 1).toString(36).substring(7)}>
                  {renderCondition(el, isNegated, module)}
                  {operation.elements && i !== operation.elements.length - 1
                    ? " and "
                    : ""}
                </Fragment>
              );
            }
          })}
        {operation.elements && operation.elements.length > 1 && " ) "}
      </Fragment>
    );
  }
}
